var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gh-card__actions" },
    [
      _c(
        "GenerationHistoryActionTooltip",
        { attrs: { text: _vm.$t("generation_history.actions.copy_text") } },
        [
          _c(
            "button",
            {
              staticClass: "gh-card__action",
              class: { "is-copied": _vm.isCopied },
              attrs: {
                type: "button",
                "aria-label": _vm.$t("generation_history.actions.copy_text"),
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("copy")
                },
              },
            },
            [_c("GenerationHistorySvgIcon", { attrs: { src: _vm.iconCopy } })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "GenerationHistoryActionTooltip",
        { attrs: { text: _vm.$t("generation_history.actions.download") } },
        [
          _c(
            "button",
            {
              staticClass: "gh-card__action",
              attrs: {
                type: "button",
                "aria-label": _vm.$t("generation_history.actions.download"),
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("download")
                },
              },
            },
            [
              _c("img", {
                staticClass: "gh-card__action-icon",
                attrs: { src: _vm.iconDownload, alt: "" },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "GenerationHistoryActionTooltip",
        { attrs: { text: _vm.$t("generation_history.actions.favorite") } },
        [
          _c(
            "button",
            {
              staticClass: "gh-card__action",
              class: { "is-favorite": _vm.isFavorite },
              attrs: {
                type: "button",
                "aria-label": _vm.$t("generation_history.actions.favorite"),
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("favorite")
                },
              },
            },
            [
              _c("img", {
                staticClass: "gh-card__action-icon",
                attrs: {
                  src: _vm.isFavorite ? _vm.iconStarFilled : _vm.iconStar,
                  alt: "",
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }